import { useCallback, useEffect, useRef } from 'react'

/**
 * Keeps TIFF conversion results scoped to the currently mounted page instance.
 * React StrictMode intentionally runs an effect cleanup followed by a remount
 * in development, so a boolean set only during ref initialization is not
 * sufficient here.
 */
export function useTiffConversionLifecycle(onCleanup: () => void) {
  const mountedRef = useRef(false)
  const generationRef = useRef(0)

  useEffect(() => {
    mountedRef.current = true
    generationRef.current += 1

    return () => {
      mountedRef.current = false
      generationRef.current += 1
      onCleanup()
    }
  }, [onCleanup])

  return useCallback(() => {
    const generation = generationRef.current
    return () => mountedRef.current && generationRef.current === generation
  }, [])
}
